import APIService from './APIService';

export default {
  listarJustificativas() {
    return APIService.apiCall().get('validacoes-bdgds/justificativas/listar-justificativas');
  },
  exportarJustificativas(config = {}) {
    return APIService.apiCall().get('validacoes-bdgds/justificativas/exportar-justificativas', {
      responseType: 'blob',
      ...config
    });
  },
  getJustificativa(postData) {
    return APIService.apiCall().post('validacoes-bdgds/justificativas/get-justificativa', JSON.stringify(postData));
  },
  salvarJustificativa(postData) {
    return APIService.apiCall().post('validacoes-bdgds/justificativas/salvar-justificativa', JSON.stringify(postData));
  },
  excluirJustificativa(justificativaId) {
    return APIService.apiCall().delete(`validacoes-bdgds/justificativas/excluir-justificativa/${justificativaId}`);
  }
};
